<h1 class="harp-card-title">Account Setup Complete</h1>
<p>Select the CMS application you want to go to.</p>

<p>
  <a
    class="harp-destination-link"
    href="https://5huhhgk4.optimalworkshop.com/questions/48cqjh18"
    target="_blank"
    >Give us feedback <strong class="icon ion-md-open"></strong
  ></a>
  <br />
  <span class="harp-help-text">Help us improve HARP</span>
</p>
<hr class="harp-dark-divider" />

<div *ngFor="let program of programs">
  <p>
    <a class="harp-destination-link" href="{{ program.Link }}"
      >Sign in to {{ program.programName }}
      <strong class="icon ion-md-open"></strong
    ></a>
    <br />
    <span class="harp-help-text">{{ program.Description }}</span>
  </p>
  <hr />
</div>

<p>
  <a
    class="harp-destination-link"
    [routerLink]="['/']"
    queryParamsHandling="merge"
    >Sign in to HARP user profile
    <strong class="icon ion-md-arrow-round-forward"></strong
  ></a>
  <br />
  <span class="harp-help-text">HCQIS Access Roles and Profile</span>
</p>
